export const EventsData = [
  {
    eventID: "10001",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10002",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10003",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10004",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10005",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10006",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10007",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10008",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10009",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10010",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
  {
    eventID: "10011",
    trip_post_date: "03/06/2024",
    trip_start_date: "05/06/2024",
    trip_status: "Upcoming",
    review_status: "Reviewed",
  },
];

export const EventDetails = {
  eventID: "10011",
  trip_organiser: "Komaraju Bablu",
  trip_post_date: "03/06/2024",
  trip_start_date: "05/06/2024",
  trip_end_date: "07/06/2024",
  start_location: "Ongole",
  trip_destination: "Macherla",
  trip_categories: ["beach", "wine", "nature"],
  no_of_slots: "20",
  trip_title: "A trip to macherla",
  trip_status: "Upcoming",
  estimated_cost: "20 Euro",
  last_date_to_register: "03/06/2024",
  organising_cost: "12 Euro",
  event_chat_link: "qwerty",
  meeting_point: "ongole",
  review_status: "Reviewed",
};

export const AllEventsData = [
  {
    ID_event: "00000001",
    accommodation: [],
    admin_approval: null,
    co_host: true,
    destination: "Nellore, Andhra Pradesh, India",
    disable_accommodation: true,
    disable_entry_tickets_and_activities: true,
    disable_expenses: false,
    disable_miscellaneous: true,
    disable_travel: false,
    enable_waitlist: true,
    end_date: "2024-06-04",
    end_lan: "79.98645599999999",
    end_lat: "14.4425987",
    end_time: "09:30",
    entry_tickets_and_activities: [],
    event_chat_link: "",
    event_created_at: "2024-05-31T05:44:00.617Z",
    event_creator: {
      signup_date: Array(0),
      _id: "66594bfe8f82a6c9d175c61e",
      profile_id: 10000004,
      firstName: "Saankhya",
      lastName: "Katari",
    },
    event_image: null,
    event_status: "created",
    is_event_free: true,
    itinerary: [],
    last_date_to_register: ["2024-06-20", "12:30"],
    meeting_lan: "79.9929798",
    meeting_lat: "14.9131806",
    meeting_point: "Kavali, Andhra Pradesh, India",
    miscellaneous: [],
    no_of_slots: 5,
    organizer_average_rating: 0,
    organizers: "Saankhya Katari",
    organizing_cost: [],
    participants: [
      {
        accept_termstrueamount_paid: null,
        booking_datetime: ["2024-05-31", " 11:33"],
        booking_id: "38zkcv4jq6qlwua3jkt",
        cancellation_datetime: [],
        co_host_status: null,
        co_organiser: null,
        email: "komarajubablu@gmail.com",
        first_name: "Komaraju",
        full_name: null,
        last_name: "Bablu",
        mobile_number: null,
        slot_status: "confirmed",
        amount_paid: "2000",
        cancellation_datetime: "23/09/2022",
        refund_status: "Approved",
        user_id: {
          email: "komarajubablu@gmail.com",
          firstName: "Komaraju",
          gender: "Male",
          lastName: "Bablu",
          profile_image: null,

          _id: "665952de8f82a6c9d175c65c",
        },
        _id: "665968448f82a6c9d175c7a4",
      },
      {
        accept_termstrueamount_paid: null,
        booking_datetime: ["2024-05-31", " 11:33"],
        booking_id: "38zkcv4jq6qlwua3jkv",
        cancellation_datetime: [],
        co_host_status: null,
        co_organiser: null,
        email: "komaraju@gmail.com",
        first_name: "Komaraju",
        full_name: null,
        last_name: "Vamsi",
        mobile_number: "6380681455",
        slot_status: "Cancelled",
        amount_paid: "3000",
        cancellation_datetime: "23/09/2022",
        refund_status: "Approved",
        user_id: {
          email: "komarajubablu@gmail.com",
          firstName: "Komaraju",
          gender: "Male",
          lastName: "Bablu",
          profile_image: null,
          _id: "665952de8f82a6c9d175c65c",
        },
        _id: "665968448f82a6c9d175c7a4",
      },
      {
        accept_termstrueamount_paid: null,
        booking_datetime: ["2024-05-31", " 11:33"],
        booking_id: "38zkcv4jq6qlwua3jvk",
        cancellation_datetime: [],
        co_host_status: null,
        co_organiser: null,
        email: "komaraju1772@gmail.com",
        first_name: "Komaraju",
        full_name: null,
        last_name: "Krishna",
        mobile_number: "6380681455",
        slot_status: "Waiting",
        amount_paid: "3000",
        cancellation_datetime: "23/09/2022",
        refund_status: "Approved",
        user_id: {
          email: "komarajubablu@gmail.com",
          firstName: "Komaraju",
          gender: "Male",
          lastName: "Bablu",
          profile_image: null,
          _id: "665952de8f82a6c9d175c65c",
        },
        _id: "665968448f82a6c9d175c7a4",
      },
    ],
    popular_trip: false,
    save_draft: false,
    start_date: "2024-06-01",
    start_lan: "80.049922",
    start_lat: "15.5057232",
    start_location: "Ongole, Andhra Pradesh, India",
    start_time: "12:30",
    time_zone: "IST",
    total_cost: [],
    travel: [],
    trip_categories: ["Beach", "Food Tour"],
    trip_description: "Nellore chapala pulusu ",
    trip_images: [
      "https://meetbytravel.s3.us-east-2.amazonaws.com/Araku_valley_view.jpg",
      "https://meetbytravel.s3.us-east-2.amazonaws.com/Araku_valley_view.jpg",
      "https://meetbytravel.s3.us-east-2.amazonaws.com/QT-O3-5.jpg",
      "https://meetbytravel.s3.us-east-2.amazonaws.com/1660899518_kodai-lake-1.jpg",
      "https://meetbytravel.s3.us-east-2.amazonaws.com/20…_04.409Z-12e2f75b-f0c5-4a3f-9826-26cc5f9f460f.jpg",
    ],
    trip_title: "Trip to Nellore",
    _id: "665963a18f82a6c9d175c68c",
  },
  {
    ID_event: "00000002",
    accommodation: [],
    admin_approval: null,
    co_host: true,
    destination: "Nellore, Andhra Pradesh, India",
    disable_accommodation: true,
    disable_entry_tickets_and_activities: true,
    disable_expenses: false,
    disable_miscellaneous: true,
    disable_travel: false,
    enable_waitlist: true,
    end_date: "2024-06-04",
    end_lan: "79.98645599999999",
    end_lat: "14.4425987",
    end_time: "09:30",
    entry_tickets_and_activities: [],
    event_chat_link: "",
    event_created_at: "2024-05-31T05:44:00.617Z",
    event_creator: {
      signup_date: Array(0),
      _id: "66594bfe8f82a6c9d175c61e",
      profile_id: 10000004,
      firstName: "Saankhya",
      lastName: "Katari",
    },
    event_image: null,
    event_status: "created",
    is_event_free: true,
    itinerary: [],
    last_date_to_register: ["2024-06-20", "12:30"],
    meeting_lan: "79.9929798",
    meeting_lat: "14.9131806",
    meeting_point: "Kavali, Andhra Pradesh, India",
    miscellaneous: [],
    no_of_slots: 5,
    organizer_average_rating: 0,
    organizers: "Saankhya Katari",
    organizing_cost: [],
    participants: [
      {
        accept_termstrueamount_paid: null,
        booking_datetime: ["2024-05-31", " 11:33"],
        booking_id: "38zkcv4jq6qlwua3qwe",
        cancellation_datetime: [],
        co_host_status: null,
        co_organiser: null,
        email: "komarajubablu@gmail.com",
        first_name: "Komaraju",
        full_name: null,
        last_name: "Bablu",
        mobile_number: null,
        slot_status: "confirmed",
        amount_paid: "3000",
        cancellation_datetime: "23/09/2022",
        refund_status: "Approved",
        user_id: {
          email: "komarajubablu@gmail.com",
          firstName: "Komaraju",
          gender: "Male",
          lastName: "Bablu",
          profile_image: null,
          _id: "665952de8f82a6c9d175c65c",
        },
        _id: "665968448f82a6c9d175c7a4",
      },
      {
        accept_termstrueamount_paid: null,
        booking_datetime: ["2024-05-31", " 11:33"],
        booking_id: "38zkcv4jq6qlwua3okv",
        cancellation_datetime: [],
        co_host_status: null,
        co_organiser: null,
        email: "komaraju@gmail.com",
        first_name: "Komaraju",
        full_name: null,
        last_name: "Vamsi",
        mobile_number: "6380681455",
        slot_status: "Cancelled",
        amount_paid: "3000",
        cancellation_datetime: "23/09/2022",
        refund_status: "Approved",
        user_id: {
          email: "komarajubablu@gmail.com",
          firstName: "Komaraju",
          gender: "Male",
          lastName: "Bablu",
          profile_image: null,
          _id: "665952de8f82a6c9d175c65c",
        },
        _id: "665968448f82a6c9d175c7a4",
      },
      {
        accept_termstrueamount_paid: null,
        booking_datetime: ["2024-05-31", "11:33"],
        booking_id: "38zkcv4jq6qlwua3kvk",
        cancellation_datetime: [],
        co_host_status: null,
        co_organiser: null,
        email: "komaraju1772@gmail.com",
        first_name: "Komaraju",
        full_name: null,
        last_name: "Krishna",
        mobile_number: "6380681455",
        slot_status: "Waiting",
        amount_paid: "3000",
        cancellation_datetime: "23/09/2022",
        refund_status: "Approved",
        user_id: {
          email: "komarajubablu@gmail.com",
          firstName: "Komaraju",
          gender: "Male",
          lastName: "Bablu",
          profile_image: null,
          _id: "665952de8f82a6c9d175c65c",
        },
        _id: "665968448f82a6c9d175c7a4",
      },
    ],
    popular_trip: false,
    save_draft: false,
    start_date: "2024-06-01",
    start_lan: "80.049922",
    start_lat: "15.5057232",
    start_location: "Ongole, Andhra Pradesh, India",
    start_time: "12:30",
    time_zone: "IST",
    total_cost: [],
    travel: [],
    trip_categories: ["Beach", "Food Tour"],
    trip_description: "Nellore chapala pulusu ",
    trip_images: [
      "https://meetbytravel.s3.us-east-2.amazonaws.com/Araku_valley_view.jpg",
      "https://meetbytravel.s3.us-east-2.amazonaws.com/Araku_valley_view.jpg",
      "https://meetbytravel.s3.us-east-2.amazonaws.com/QT-O3-5.jpg",
      "https://meetbytravel.s3.us-east-2.amazonaws.com/1660899518_kodai-lake-1.jpg",
      "https://meetbytravel.s3.us-east-2.amazonaws.com/20…_04.409Z-12e2f75b-f0c5-4a3f-9826-26cc5f9f460f.jpg",
    ],
    trip_title: "Trip to Nellore",
    _id: "665963a18f82a6c9d175c68c",
  },
];

const dataOfUser = [
  {
    profileId: 1,
    OnboardingID: "87689676",
    FullName: "John doe",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 2,
    OnboardingID: "87689676",
    FullName: "Jacob Marcus",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 3,
    OnboardingID: "87689676",
    FullName: "John doe",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 4,
    OnboardingID: "87689676",
    FullName: "Jacob Marcus",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 5,
    OnboardingID: "87689676",
    FullName: "John doe",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 6,
    OnboardingID: "87689676",
    FullName: "Jacob Marcus",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 7,
    OnboardingID: "87689676",
    FullName: "John doe",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 8,
    OnboardingID: "87689676",
    FullName: "Jacob Marcus",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 9,
    OnboardingID: "87689676",
    FullName: "John doe",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 10,
    OnboardingID: "87689676",
    FullName: "John doe",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 11,
    OnboardingID: "87689676",
    FullName: "John doe",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  {
    profileId: 12,
    OnboardingID: "87689676",
    FullName: "John doe",
    email: "john.doe@example.com",
    OrganiserStatus: "Pending",
  },
  // Add more sample data here
];


export const ContentManagementData = [
  {
    ID_event: '00000004',
    trip_start_date: "2024-05-08",
    trip_organiser: "Vyshnavi",
    trip_title: "Hello kashmir"
  },
  {
    ID_event: '00000005',
    trip_start_date: "2024-06-08",
    trip_organiser: "Angel",
    trip_title: " Lets explore Iceland 🇮🇸  and hiking near the area"
  },
  {
    ID_event: '00000006',
    trip_start_date: "2024-05-09",
    trip_organiser: "Thejaswini",
    trip_title: "Trip to Hyderabad"
  },
  {
    ID_event: '00000007',
    trip_start_date: "2024-05-05",
    trip_organiser: "Vamsi",
    trip_title: " Lets explore Iceland 🇮🇸  and hiking near the area"
  },
  {
    ID_event: '00000008',
    trip_start_date: "2024-05-03",
    trip_organiser: "Saankhya",
    trip_title: " Lets explore Iceland 🇮🇸  and hiking near the area"
  }
]

export const filteredEvents = [
  {
    ID_event: '00000004',
    trip_start_date: "2024-05-08",
    trip_organiser: "Vyshnavi",
    trip_title: "Hello kashmir"
  },
  {
    ID_event: '00000005',
    trip_start_date: "2024-06-08",
    trip_organiser: "Angel",
    trip_title: " Lets explore Iceland 🇮🇸  and hiking near the area"
  },
  {
    ID_event: '00000006',
    trip_start_date: "2024-05-09",
    trip_organiser: "Thejaswini",
    trip_title: "Trip to Hyderabad"
  },
  {
    ID_event: '00000007',
    trip_start_date: "2024-05-05",
    trip_organiser: "Vamsi",
    trip_title: " Lets explore Iceland 🇮🇸  and hiking near the area"
  },
  {
    ID_event: '00000008',
    trip_start_date: "2024-05-03",
    trip_organiser: "Saankhya",
    trip_title: " Lets explore Iceland 🇮🇸  and hiking near the area"
  }
]

export const OrganiserReportData = [
  {
    ProfileID: '00000004',
    Country: "India",
    Full_Name: "Vyshnavi",
    my_events: 2,
    my_organised_trips: 3,
    last_active: '24-06-2024',
    organisers_rating: 3.5
  },
]

export const BookingMetricsData = [
  {
    EventID: '00000004',
    Start_location: "India",
    Full_Name: "Vyshnavi",
    my_events: 2,
    Total_Revenue: 3,
    Total_cashback: 400,
    Event_Date: '24-06-2024',
    Organiser_profit: '75%',
  }
]